import moment from 'moment';

export default (expectedLocale = 'ru') => {
  moment.locale(expectedLocale);
  const currentLocale = moment.locale();
  if (currentLocale !== expectedLocale) {
    moment.locale('en');
  }
};
